import { Record } from 'immutable';

const {
    GET_SESSIONS_REQUEST,
    GET_SESSIONS_SUCCESS,
    GET_SESSIONS_FAILURE,

    GET_SESSION_RECORDS_REQUEST,
    GET_SESSION_RECORDS_SUCCESS,
    GET_SESSION_RECORDS_FAILURE,

    CREATE_SESSION_REQUEST,
    CREATE_SESSION_SUCCESS,
    CREATE_SESSION_FAILURE,

    UPDATE_SESSION_REQUEST,
    UPDATE_SESSION_SUCCESS,
    UPDATE_SESSION_FAILURE,

    DELETE_SESSION_REQUEST,
    DELETE_SESSION_SUCCESS,
    DELETE_SESSION_FAILURE,
} = require('./sessionActions').constants;

const InitialState = Record({
    isFetching: false,
    error: null,
    sessions: [],
    sessionRecords: [],
    currentSession: null,
    pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0,
    },
});

const initialState = new InitialState();

export default function sessionReducer(state = initialState, { payload, type }) {
    if (!(state instanceof InitialState)) return initialState.merge(state);

    switch (type) {
    case GET_SESSIONS_REQUEST:
    case GET_SESSION_RECORDS_REQUEST:
    case CREATE_SESSION_REQUEST:
    case UPDATE_SESSION_REQUEST:
    case DELETE_SESSION_REQUEST:
        return state.set('isFetching', true)
            .set('error', null);

    case GET_SESSIONS_SUCCESS:
        return state.set('isFetching', false)
            .set('sessions', payload.data || [])
            .set('pagination', {
                current_page: payload.current_page || 1,
                last_page: payload.last_page || 1,
                per_page: payload.per_page || 10,
                total: payload.total || 0,
            });

    case GET_SESSION_RECORDS_SUCCESS:
        return state.set('isFetching', false)
            .set('sessionRecords', payload.data || []);

    case CREATE_SESSION_SUCCESS:
    case UPDATE_SESSION_SUCCESS:
        return state.set('isFetching', false)
            .set('currentSession', payload.assessmentRecord || payload.session);

    case DELETE_SESSION_SUCCESS:
        return state.set('isFetching', false);

    case GET_SESSIONS_FAILURE:
    case GET_SESSION_RECORDS_FAILURE:
    case CREATE_SESSION_FAILURE:
    case UPDATE_SESSION_FAILURE:
    case DELETE_SESSION_FAILURE:
        return state.set('isFetching', false)
            .set('error', payload);

    default:
        return state;
    }
}
